module.exports = __webpack_public_path__ + "img/blog-1.0d3a2f1a.png";